<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {MenuItem} from '@rgossiaux/svelte-headlessui';
    import {exists} from 'shared/utils/custom-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let isDisabled = false;
    export let dataQa: string | null = null;
    export let additionalClasses = '';
    export let href: string | null = null;
    export let icon: UIcons | null = null;
</script>

<MenuItem as="li" disabled={isDisabled} let:disabled let:active on:click>
    {#if exists(href) && !isDisabled}
        <a {href} class="dropdown-menu-item {additionalClasses}" data-qa={dataQa} class:disabled class:active>
            <span class="button-label">
                <slot/>
            </span>

            {#if !exists($$slots.icon)}
                {#if exists(icon)}
                    <span class="icon-container">
                        <UIcon {icon}/>
                    </span>
                {/if}
            {:else}
                <slot name="icon"/>
            {/if}
        </a>
    {:else}
        <span class="dropdown-menu-item {additionalClasses}" data-qa={dataQa} class:disabled class:active>
            <span class="button-label">
                <slot/>
            </span>

            {#if !exists($$slots.icon)}
                {#if exists(icon)}
                    <span class="icon-container">
                        <UIcon {icon}/>
                    </span>
                {/if}
            {:else}
                <slot name="icon"/>
            {/if}
        </span>
    {/if}
</MenuItem>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .dropdown-menu-item {
        display: flex;
        align-items: center;
        padding: @spacing-xs @spacing-m;
        gap: @spacing-m;
        font-weight: normal;
        border-radius: @border-radius-default;
        color: var(--text-default);
        white-space: nowrap;
        text-decoration: none;
        cursor: pointer;

        &.disabled {
            opacity: 0.5;
            background-color: @themed-disabled-bg;
            cursor: not-allowed;
        }

        &.active {
            background-color: @themed-body-bg-blue-highlighted;
        }

        .button-label {
            flex: 1;
            text-align: start;
            font-size: @font-size-sm;
        }

        .icon-container {
            color: @themed-text-muted;
            font-size: @font-size-small;
        }
    }
</style>